import {
  Stack as ChakraStack,
  HStack as ChakraHStack,
  VStack as ChakraVStack,
} from '@chakra-ui/react';

export const Stack = ChakraStack;
export const HStack = ChakraHStack;
export const VStack = ChakraVStack;
